import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group"
import type { StaffCalendarView } from "../lib/staffDay"

/**
 * Week or day, for the staff calendar (AB#766). A single-choice toggle group, so it is announced as
 * one control with the current choice pressed, and arrow keys move between the two.
 *
 * Choosing the one already chosen does nothing rather than clearing it: Radix reports that as an
 * empty value, and a calendar drawing neither is not a state the page has.
 */
export function StaffViewToggle({ view, onChange }: {
  view: StaffCalendarView
  onChange: (view: StaffCalendarView) => void
}) {
  return (
    <ToggleGroup
      type="single"
      variant="outline"
      size="sm"
      value={view}
      onValueChange={value => { if (value === "week" || value === "day") onChange(value) }}
      aria-label="Calendar view"
    >
      <ToggleGroupItem value="week">Week</ToggleGroupItem>
      <ToggleGroupItem value="day">Day</ToggleGroupItem>
    </ToggleGroup>
  )
}
